import { register, SwiperContainer } from 'swiper/element/bundle';
if (typeof window !== 'undefined' && SwiperContainer && SwiperContainer.prototype) {
	const origConnectedCallback = SwiperContainer.prototype.connectedCallback;
	SwiperContainer.prototype.connectedCallback = function () {
		if (this.init === false || this.getAttribute('init') === 'false') {
			if (typeof this.render === 'function') {
				this.render();
			}
			return;
		}
		if (origConnectedCallback) {
			origConnectedCallback.call(this);
		}
	};
}

register();
